import { render, staticRenderFns } from "./DownloadWin34.vue?vue&type=template&id=4d078b5e&scoped=true"
import script from "./DownloadWin34.vue?vue&type=script&lang=js"
export * from "./DownloadWin34.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d078b5e",
  null
  
)

export default component.exports